module.exports = "/assets/data/74f3d9521ad70ac4cb486a7d4227651f-L39.data.json";